<template>
    <el-row>
        <el-row>
            <h3>基本设置</h3>
        </el-row>
        <el-row>
            <el-form label-width="120px">
                <el-form-item label="允许下架: ">
                    <el-switch
                            v-model="allowedOffShelves"
                            :change="updateOffShelves">
                    </el-switch>
                </el-form-item>
            </el-form>
        </el-row>
    </el-row>

</template>

<script>
    export default {
        name: "Setting",
        data() {
            return {
                allowedOffShelves: false

            }
        },
        methods: {
            updateOffShelves: function() {
                this.$store.commit("updateAllowedOffShelves", this.allowedOffShelves);
            }
        }
    }
</script>

<style scoped>

</style>